module.exports = __webpack_public_path__ + "static/media/send-icon-inactive.6b5ef370.svg";